import React from 'react';
import PropTypes from 'prop-types';
import Script from 'react-load-script';

const BroadbandCompareTrackingPixel = (props) => {
  const handleScriptLoad = () => { /* Script requires an onLoad function */ };
  const handleScriptError = e => console.error('Could not load tracking pixel', e);  // eslint-disable-line

  window.afid = encodeURIComponent(props.trackingId);
  window.afgoal = 'signup';
  window.afsecure = '1f740c861722605abf2c1eadfd78102c';
  window.afcurrency = 'NZD';

  return (
    <Script
      url="//track.roeye.co.nz/track.js"
      onLoad={handleScriptLoad}
      onError={e => handleScriptError(e)}
    />
  );
};

BroadbandCompareTrackingPixel.propTypes = {
  trackingId: PropTypes.string
};

export default BroadbandCompareTrackingPixel;



/** WEBPACK FOOTER **
 ** ./src/components/tracking/BroadbandCompare/BroadbandCompareTrackingPixel.js
 **/